import React from "react";
import { AlertTriangle, Bell, X } from "lucide-react";
import {
    getAndroidReminderSetupStatus,
    requestAndroidReminderSetup,
} from "../utils/taskReminderSync";

const TaskReminderSetupBanner = ({ dismissed, onDismiss }) => {
    const status = getAndroidReminderSetupStatus();
    if (!status.isAndroid || !status.needsSetup || dismissed) return null;

    return (
        <div className="mb-3 rounded-xl border border-warning/40 bg-warning/10 px-3 py-2.5 flex items-start gap-2">
            <Bell size={16} className="text-warning shrink-0 mt-0.5" />
            <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold text-ink">Enable reliable task reminders</p>
                <p className="text-[11px] text-ink-muted mt-0.5">
                    {!status.hasNotification && "Allow notifications. "}
                    {!status.hasExactAlarm && "Allow alarms & reminders in Android settings. "}
                    Assigned tasks ring on the assignee&apos;s phone; unassigned tasks ring on admin.
                </p>
                <button
                    type="button"
                    onClick={requestAndroidReminderSetup}
                    className="mt-2 text-xs font-semibold text-primary hover:underline"
                >
                    Enable now
                </button>
            </div>
            <button
                type="button"
                onClick={onDismiss}
                className="p-1 rounded-lg text-ink-muted hover:bg-surface-2"
                aria-label="Dismiss"
            >
                <X size={14} />
            </button>
        </div>
    );
};

export function MissedRemindersBar({ tasks = [], onOpenTask, onDismissTask }) {
    if (!tasks.length) return null;

    return (
        <div className="mb-3 rounded-xl border border-error/30 bg-error/10 px-3 py-2.5">
            <div className="flex items-center gap-2 mb-2">
                <AlertTriangle size={16} className="text-error shrink-0" />
                <p className="text-xs font-semibold text-ink">
                    {tasks.length} missed reminder{tasks.length > 1 ? "s" : ""}
                </p>
            </div>
            <ul className="space-y-1">
                {tasks.slice(0, 3).map((task) => (
                    <li key={task.id} className="flex items-center justify-between gap-2 text-xs">
                        <button
                            type="button"
                            onClick={() => onOpenTask?.(task)}
                            className="text-left text-ink-secondary hover:text-primary truncate"
                        >
                            {task.title}
                        </button>
                        <button
                            type="button"
                            onClick={() => onDismissTask?.(task)}
                            className="shrink-0 text-ink-muted hover:text-ink"
                            aria-label="Dismiss"
                        >
                            <X size={12} />
                        </button>
                    </li>
                ))}
            </ul>
            {tasks.length > 3 && (
                <p className="text-[11px] text-ink-muted mt-1">+{tasks.length - 3} more</p>
            )}
        </div>
    );
}

export default TaskReminderSetupBanner;
